import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo } from "react";
import { OnboardingProps } from "../common";
import { CROSS_SELL_POPUP_URL } from "../index";

export const PackageProtectionPlusOnboarding = memo(
  function PackageProtectionPlusOnboarding({
    handleDismiss,
    handleComplete,
  }: OnboardingProps) {
    const handleAction = () => {
      window.open(`${CROSS_SELL_POPUP_URL}/pp-one-pager.pdf`, "_blank");
      handleComplete();
    };

    return (
      <RedoFeatureNotificationCard
        actionText="Learn more"
        description="Tired of managing your claims? Let us handle it for you!"
        image={`${CROSS_SELL_POPUP_URL}/pp-popup.png`}
        onAction={handleAction}
        onDismiss={handleDismiss}
        title="Package Protection+"
      />
    );
  },
);
